import { Star, Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Margaret R.",
    location: "Tampa, FL",
    text: "I was worried about what my children would face. Legacy Security Life made it so simple. The agent was kind, never pushy, and I locked in $15,000 of coverage for less than I spend on cable.",
  },
  {
    name: "Robert & Linda K.",
    location: "Phoenix, AZ",
    text: "We compared three different agencies. Legacy gave us the most coverage for our budget — and they actually listened. The whole process took maybe 20 minutes from quote to coverage.",
  },
  {
    name: "Doris W.",
    location: "Atlanta, GA",
    text: "After my husband passed, I realized I had nothing in place for myself. They walked me through everything in plain English. I sleep so much better knowing my kids won't have to scramble.",
  },
];

export default function Testimonials() {
  return (
    <section className="py-20 lg:py-28 bg-ivory" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-xs sm:text-sm uppercase tracking-[0.22em] text-gold-deep font-semibold">From Our Families</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-navy leading-tight mt-3">
            Real Stories From People We've Helped Protect.
          </h2>
          <div className="accent-line mt-5" />
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-6 lg:gap-8">
          {TESTIMONIALS.map((t) => (
            <figure
              key={t.name}
              data-testid={`testimonial-${t.name.split(" ")[0].toLowerCase()}`}
              className="bg-white border border-border rounded-xl p-7 flex flex-col lift-on-hover"
            >
              <Quote className="h-7 w-7 text-[#C5A059]" />
              <div className="flex items-center gap-0.5 mt-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} className="h-4 w-4 fill-[#C5A059] text-[#C5A059]" />
                ))}
              </div>
              <blockquote className="text-navy/85 mt-4 text-base leading-relaxed flex-1">
                "{t.text}"
              </blockquote>
              <figcaption className="mt-5 border-t border-border pt-4">
                <p className="font-serif text-lg text-navy">{t.name}</p>
                <p className="text-sm text-muted-foreground">{t.location}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
